var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path0, _path1, _path10, _path11, _circle, _circle2, _path12, _path13, _path14, _path15, _path16, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,14.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-6C16,15.672842,15.3271484,14.9999905,14.5,14.9999905z",
    fill: "#82C341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,23.7499905c-0.8271484,0-1.5-0.6728516-1.5-1.5v0.25c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-0.25C16,23.0771389,15.3271484,23.7499905,14.5,23.7499905z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,14.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-6C11,15.672842,10.3271484,14.9999905,9.5,14.9999905z",
    fill: "#82C341"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,23.7499905c-0.8271484,0-1.5-0.6728516-1.5-1.5v0.25c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-0.25C11,23.0771389,10.3271484,23.7499905,9.5,23.7499905z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7.9999905H6v9c0,1.1045685,0.8954306,2,2,2h8c1.1045704,0,2-0.8954315,2-2V7.9999905z",
    fill: "#82C341"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-6C22,8.672842,21.3271484,7.9999905,20.5,7.9999905z",
    fill: "#82C341"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1264648,2.8105371c-0.1669922,0-0.3305664-0.0834961-0.425293-0.2358398L7.5751953,0.7641505   c-0.1455078-0.234375-0.0737305-0.5429688,0.1606445-0.6889648c0.2353516-0.1450195,0.5429688-0.0742188,0.6889648,0.1606445   l1.1259766,1.8105468c0.1455078,0.234375,0.0737305,0.5429688-0.1606445,0.6889648   C9.3076172,2.786123,9.2167969,2.8105371,9.1264648,2.8105371z",
    fill: "#82C341"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8735352,2.8105371c-0.090332,0-0.1811523-0.0244141-0.2636719-0.0751953   c-0.234375-0.1459961-0.3061523-0.4545898-0.1606445-0.6889648l1.1259766-1.8105468   c0.1459961-0.2348633,0.4536133-0.3056641,0.6889648-0.1606445c0.234375,0.1459961,0.3061523,0.4545898,0.1606445,0.6889648   l-1.1259766,1.8105468C15.2041016,2.727041,15.0405273,2.8105371,14.8735352,2.8105371z",
    fill: "#82C341"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0.9999903c-3.3137207,0-6,2.6862793-6,6h12C18,3.6862695,15.3137207,0.9999903,12,0.9999903z",
    fill: "#82C341"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 12,
    x: 6,
    y: 7.9999905
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18.7499905H8c-1.1045532,0-2-0.8954468-2-2v0.25c0,1.1045532,0.8954468,2,2,2h8   c1.1045532,0,2-0.8954468,2-2v-0.25C18,17.8545437,17.1045532,18.7499905,16,18.7499905z",
    opacity: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v0.25c0-0.8271484,0.6728516-1.5,1.5-1.5   s1.5,0.6728516,1.5,1.5v-0.25C22,8.672842,21.3271484,7.9999905,20.5,7.9999905z",
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,16.7499905c-0.8271484,0-1.5-0.6728516-1.5-1.5v0.25c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-0.25C22,16.0771389,21.3271484,16.7499905,20.5,16.7499905z",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12,1.2499903c2.513855,0,4.6652832,1.460168,5.6008911,3.5937738   C16.743042,2.5788717,14.5655518,0.9999903,12,0.9999903S7.2553658,2.5830119,6.3975167,4.8479047   C7.3331246,2.7142985,9.486145,1.2499903,12,1.2499903z",
    fill: "#FFFFFF",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 4.4999905,
    fill: "#FFFFFF",
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.4999905,
    fill: "#FFFFFF",
    r: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0126343,6.7499905C6.0091553,6.8335476,6,6.9155788,6,6.9999905h12   c0-0.0844116-0.0091553-0.1664429-0.0126343-0.25H6.0126343z",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-6C5,8.672842,4.3271484,7.9999905,3.5,7.9999905z",
    fill: "#82C341"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v0.25c0-0.8271484,0.6728516-1.5,1.5-1.5   s1.5,0.6728516,1.5,1.5v-0.25C5,8.672842,4.3271484,7.9999905,3.5,7.9999905z",
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,16.7499905c-0.8271484,0-1.5-0.6728516-1.5-1.5v0.25c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-0.25C5,16.0771389,4.3271484,16.7499905,3.5,16.7499905z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 2.815382,
    x2: 21.7960167,
    y1: 7.4190083,
    y2: 16.2698231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16.9999905c0,1.1045532,0.8954468,2,2,2v3.5c0,0.8271484,0.6728516,1.5,1.5,1.5   s1.5-0.6728516,1.5-1.5v-3.5h2v3.5c0,0.8271484,0.6728516,1.5,1.5,1.5s1.5-0.6728516,1.5-1.5v-3.5c1.1045532,0,2-0.8954468,2-2v-9   H6V16.9999905z M20.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6c0,0.8271484,0.6728516,1.5,1.5,1.5s1.5-0.6728516,1.5-1.5v-6   C22,8.672842,21.3271484,7.9999905,20.5,7.9999905z M15.5500488,2.1707666l0.8747559-1.4066161   c0.1455078-0.234375,0.0737305-0.5429688-0.1606445-0.6889648c-0.2353516-0.1450195-0.5429688-0.0742188-0.6889648,0.1606445   l-0.8770752,1.4103394C13.8862915,1.2361964,12.9716187,0.9999903,12,0.9999903s-1.8862915,0.2362061-2.6981201,0.6461792   L8.4248047,0.2358302C8.2788086,0.0009669,7.9711914-0.0698339,7.7358398,0.0751856   c-0.234375,0.1459961-0.3061523,0.4545898-0.1606445,0.6889648l0.8747559,1.4066161C6.9666138,3.2631738,6,5.016531,6,6.9999905h12   C18,5.016531,17.0333862,3.2631738,15.5500488,2.1707666z M3.5,7.9999905c-0.8271484,0-1.5,0.6728516-1.5,1.5v6   c0,0.8271484,0.6728516,1.5,1.5,1.5s1.5-0.6728516,1.5-1.5v-6C5,8.672842,4.3271484,7.9999905,3.5,7.9999905z",
    fill: "url(#SVGID_1_)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.c717c700f5828a1a42b5be9de8a5a2c1.svg";
export { ForwardRef as ReactComponent };